import React from 'react';
import { MapPin, Calendar, Info, Clock } from 'lucide-react';
import { weddingDetails } from '../data/mock';
import { useLanguage } from '../LanguageContext';

export const WeddingDetails = () => {
  const { t } = useLanguage();
  
  const openInMaps = () => {
    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${weddingDetails.coordinates.lat},${weddingDetails.coordinates.lng}`;
    window.open(mapsUrl, '_blank');
  };

  return (
    <section id="wedding-details" className="wedding-details-section">
      <div className="container">
        <div className="section-header">
          <Calendar className="section-icon" />
          <h2 className="section-title">{t('details.title')}</h2>
          <div className="decorative-line-small"></div>
        </div>

        <div className="details-grid">
          <div className="detail-card" data-aos="fade-up">
            <div className="detail-icon-wrapper">
              <Calendar className="detail-icon" />
            </div>
            <h3 className="detail-title">{t('details.date')}</h3>
            <p className="detail-text">{t('details.dateValue')}</p>
          </div>

          <div className="detail-card" data-aos="fade-up" data-aos-delay="100">
            <div className="detail-icon-wrapper">
              <Clock className="detail-icon" />
            </div>
            <h3 className="detail-title">{t('details.time')}</h3>
            <p className="detail-text">{t('details.timeValue')}</p>
          </div>

          <div className="detail-card" data-aos="fade-up" data-aos-delay="200">
            <div className="detail-icon-wrapper">
              <MapPin className="detail-icon" />
            </div>
            <h3 className="detail-title">{t('details.location')}</h3>
            <p className="detail-text">{t('details.locationName')}</p>
            <p className="detail-subtext">{t('details.locationAddress')}</p>
            <button onClick={openInMaps} className="map-button">
              <MapPin size={18} />
              {t('details.directions')}
            </button>
          </div>
        </div>

        <div className="venue-info" data-aos="fade-up">
          <Info className="venue-icon" />
          <h3 className="venue-title">{t('details.venueTitle')}</h3>
          <p className="venue-description">{t('details.venueDescription')}</p>
        </div>
      </div>
    </section>
  );
};

export default WeddingDetails;
